export const ConnectionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="9"
      cy="11.5"
      r="5.25"
      transform="rotate(90 9 11.5)"
      stroke="#C8CFDB"
      strokeOpacity="0.8"
      strokeWidth="1.5"
    />
    <circle
      cx="15"
      cy="11.5"
      r="5.25"
      transform="rotate(90 15 11.5)"
      stroke="#F4F4F5"
      strokeWidth="1.5"
    />
  </svg>
);
